var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"padding":"12px"}},[_c('div',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.export4ImagesFromStock()}}},[_vm._v("导出所有在库钱币前四张图片")]),_c('div',[_vm._v("完成："+_vm._s(_vm.finish)+"/"+_vm._s(_vm.total))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }